import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import { NgbModal, NgbNavChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { of, Subscription } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { NDDBasketData } from 'src/app/models/modelNDD';
import { HomeService } from 'src/app/services/home.service';
import { MemberService } from 'src/app/services/member.service';
import Swal from 'sweetalert2';
import { NDDFunction } from 'src/app/models/modelNDD';
import { Router } from '@angular/router';
import { ConfigService } from 'src/app/services/config.service';

@Component({
  selector: 'app-rd-dialog',
  templateUrl: './rd-dialog.component.html',
  styleUrls: ['./rd-dialog.component.css'],
})
export class RdDialogComponent implements OnInit, OnDestroy {
  public isCollapsed = false;
  @Input() dataRD: any;
  @Input() mattypeID: any;
  CurentUser: any;
  FlagBLOCKUSER = 0;
  TextRD: Array<textRD> = [];
  FlagREALITEM: number = 0;
  FlagCOPY: number = 0;
  FlagFILE: number = 0;
  type = 'NDDRealItemFee';
  //page = '';
  pageCount = 0; //จำนวนหน้า
  allPage = true;
  //disabled = true;

  Fee = '';
  FG: UntypedFormGroup;
  NDDFeeSubcription: Subscription = new Subscription();
  calPageCountAndFeeSubcription: Subscription = new Subscription();
  AddToBasketSubcription: Subscription = new Subscription();
  loading: boolean = true;
  themeName!: string;

  fc = new NDDFunction(this.homeService);
  constructor(
    private modalService: NgbModal,
    private memberService: MemberService,
    private homeService: HomeService,
    private fb: UntypedFormBuilder,
    private route: Router,
    private configService: ConfigService
  ) {
    this.FG = this.fb.group({
      formControlpage: new UntypedFormControl({ value: '', disabled: true }),
      copyCount: new UntypedFormControl(1),
    });
    this.CurentUser = JSON.parse(localStorage.getItem('WALAIcurrentUser') ?? '[]') || [];
  }
  ngOnDestroy(): void {
    if (this.NDDFeeSubcription) {
      this.NDDFeeSubcription.unsubscribe();
    }
    if (this.calPageCountAndFeeSubcription) {
      this.calPageCountAndFeeSubcription.unsubscribe();
    }

    if (this.AddToBasketSubcription) {
      this.AddToBasketSubcription.unsubscribe();
    }
  }

  async ngOnInit(): Promise<void> {
    this.themeName = this.configService.themeName;
    let objRD = new textRD();
    if (localStorage.getItem('lang') == 'th') {
      objRD.TitleModal = 'Resource Delivery';
      objRD.NoticeBlockUser = 'ไม่สามารถทำรายการได้: สถานะสมาชิกมีรายการบล็อก';
      objRD.NoticeRequesttoBasket = 'เพิ่มรายการลงตะกร้าเรียบร้อยแล้ว';
    } else {
      objRD.TitleModal = 'Resource Delivery';
      objRD.NoticeBlockUser = 'Unable to request delivery: Member is blocked.';
      objRD.NoticeRequesttoBasket = 'The item has been added to the basket.';
    }

    this.TextRD.push(objRD);

    // UserSoftBlock.forEach(Datail => {});
    // UserardBlock.forEach(Datail => {
    // });

    if (this.dataRD.ITEMID.includes('j')) {
      //if (this.dataRD.PAGE != '') {
      this.pageCount = this.dataRD.PAGECOUNT;
      this.FG.controls['formControlpage'].setValue(this.dataRD.PAGE);
      this.FG.controls['copyCount'].setValue(1);
      // }

      /**สำหรับปิด tab type Realitem coppy  file */
      await this.NDDTypeOpenForArticle();
    } else {
      if (this.dataRD.PAGE != '') {
        this.pageCount = this.dataRD.PAGE;
        this.FG.controls['formControlpage'].setValue('1-' + this.dataRD.PAGE);
      }

      /**สำหรับปิด tab type Realitem coppy  file */
      await this.GetNDDTypeOpen(this.dataRD.ITEMID);
    }
  }

  async onPageChange(value : any) {
    if (value == 1) {
      this.allPage = true;
      //  this.page = this.page = '1-' + this.dataRD.PAGE;

      if (this.dataRD.ITEMID.includes('j')) {
        this.FG.controls['formControlpage'].setValue(this.dataRD.PAGE);
      } else {
        this.FG.controls['formControlpage'].setValue('1-' + this.dataRD.PAGE);
      }

      this.FG.controls['formControlpage'].disable();
    } else {
      this.allPage = false;
      this.FG.controls['formControlpage'].enable();
    }

    this.calPageCountAndFee();
    // this.pageCount = 0;

    // this.pageCount = await this.fc.calPageCount(
    //   this.FG.controls['formControlpage'].value.split(' ').join('')
    // );
  }

  closeModal() {
    this.modalService.dismissAll(this.modalService);
  }

  async changeType(type: string) {
    // this.allPage = true;
    this.FG.controls['copyCount'].setValue(1);
    this.type = type;

    if (type == 'NDDRealItemFee') {
      this.Fee = '';
      this.Fee = await this.fc.getNDDFee(
        'NDDRealItemFee',
        0,
        this.FG.controls['copyCount'].value
      );
    } else {
      this.calPageCountAndFee();
    }
  }

  async NDDTypeOpenForArticle() {
    this.FlagREALITEM = Number(this.dataRD.REALITEMFLAG);
    this.FlagCOPY = Number(this.dataRD.COPYFLAG);
    this.FlagFILE = Number(this.dataRD.FILEFLAG);

    if (this.FlagREALITEM == 1) {
      this.Fee = await this.fc.getNDDFee(
        'NDDRealItemFee',
        0,
        this.FG.controls['copyCount'].value
      );
    }
    if (this.FlagCOPY == 1) {
      this.Fee = await this.fc.getNDDFee(
        'NDDCopyFee',
        this.pageCount,
        this.FG.controls['copyCount'].value
      );
    }
    if (this.FlagFILE == 1) {
      this.Fee = await this.fc.getNDDFee(
        'NDDFileFee',
        this.pageCount,
        this.FG.controls['copyCount'].value
      );
      this.type = 'NDDFileFee'
    }
    this.loading = false
  }

  async GetNDDTypeOpen(ITEMID :string) {
    this.homeService
      .getNDDRequestTypeOpen(ITEMID)
      .subscribe(async (requesttype: any) => {
        this.FlagREALITEM = requesttype[0].REALITEMFLAG;
        this.FlagCOPY = requesttype[0].COPYFLAG;
        this.FlagFILE = requesttype[0].FILEFLAG;

        if (this.FlagREALITEM == 1) {
          this.Fee = await this.fc.getNDDFee(
            'NDDRealItemFee',
            0,
            this.FG.controls['copyCount'].value
          );
        } else {
          if (this.FlagCOPY == 1) {
            this.Fee = await this.fc.getNDDFee(
              'NDDCopyFee',
              this.pageCount,
              this.FG.controls['copyCount'].value
            );
          } else {
            if (this.FlagFILE == 1) {
              this.Fee = await this.fc.getNDDFee(
                'NDDFileFee',
                this.pageCount,
                this.FG.controls['copyCount'].value
              );
            }
          }
        }

        this.loading = false;
      });
  }

  async calPageCountAndFee() {
    this.pageCount = this.FG.controls['formControlpage'].value;
    // let fc = new NDDFunction(this.homeService)
    this.pageCount = await this.fc.calPageCount(
      // this.FG.controls['formControlpage'].value.split(' ').join('')

      this.pageCount
    );

    if (this.pageCount != 0) {
      this.Fee = await this.fc.getNDDFee(
        this.type,
        this.pageCount,
        this.FG.controls['copyCount'].value
      );
    } else {
      this.Fee = '';
    }
  }

  async AddToBasket(ProcessType : any) {
    //processType 1 == add to basket
    var type = 'Real Item';

    if (this.type == 'NDDRealItemFee') {
      this.Fee = await this.fc.getNDDFee(
        this.type,
        this.pageCount,
        this.FG.controls['copyCount'].value
      );
    } else {
      this.pageCount = this.FG.controls['formControlpage'].value;
      this.pageCount = await this.fc.calPageCount(
        //this.FG.controls['formControlpage'].value.split(' ').join('')
        this.pageCount
      );

      if (this.pageCount != 0) {
        this.Fee = await this.fc.getNDDFee(
          this.type,
          this.pageCount,
          this.FG.controls['copyCount'].value
        );
      } else {
        this.Fee = '';
      }
    }

    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        popup: this.themeName,
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-secondary me-2',
      },
      buttonsStyling: false,
    });

    var pageAndCopy = '';
    if (this.type == 'NDDCopyFee' || this.type == 'NDDFileFee') {
      type = 'NDDFileFee';
      pageAndCopy = 'Page: ' + this.FG.controls['formControlpage'].value;
    }
    if (this.type == 'NDDCopyFee') {
      type = 'NDDCopyFee';
      pageAndCopy += ', Copy: ' + this.FG.controls['copyCount'].value;
    }
    // pageAndCopy += type + '<br>'+pageAndCopy+ '<br>';
    type = type
      .replace('NDDRealItemFee', 'Real Item')
      .replace('NDDCopyFee', 'Copy')
      .replace('NDDFileFee', 'File');
    type == 'Real Item'
      ? (pageAndCopy = '(' + type + ')' + '<br>')
      : (pageAndCopy = '(' + type + ')' + '<br>' + pageAndCopy + '<br>');

    var htmlText: string =
      "<div class='alert alert-primary' role='alert'>" +
      pageAndCopy +
      '<b>Fee: ' +
      this.Fee +
      ' ฿ </b></div>';

    swalWithBootstrapButtons.fire({
      title:
        ProcessType == 1
          ? 'Are you sure add to basket?'
          : 'Are you sure request?',
      html: htmlText,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
      reverseButtons: true,
    })
      .then((result) => {
        if (result.isConfirmed) {

          if (this.CurentUser[0].USERID == null || this.CurentUser[0].USERID == '') {
            this.route.navigateByUrl('login');
            return;
          }


          //  1 - realitem, 2 - copy, 3 - File

          if (this.dataRD.ITEMID.includes('j')) {
            var basketData: NDDBasketData = {
              DDINBASKETID: '',
              DDFORMAT: type
                .replace('Real Item', '1')
                .replace('Copy', '2')
                .replace('File', '3'),
              ITEMID: '',
              JMARCID: this.dataRD.ITEMID,
              PAGE: this.FG.controls['formControlpage'].value,
              COPYNUM: this.FG.controls['copyCount'].value,
              LOCATIONID: this.dataRD.LOCATIONID,
              FEE: this.Fee,
              MATTYPEID: this.mattypeID,
              USERID: this.CurentUser[0].USERID,
            };
          } else {
            var basketData: NDDBasketData = {
              DDINBASKETID: '',
              DDFORMAT: type
                .replace('Real Item', '1')
                .replace('Copy', '2')
                .replace('File', '3'),
              ITEMID: this.dataRD.ITEMID,
              JMARCID: '',
              PAGE: this.FG.controls['formControlpage'].value,
              COPYNUM: this.FG.controls['copyCount'].value,
              LOCATIONID: this.dataRD.LOCATIONID,
              FEE: this.Fee,
              MATTYPEID: this.mattypeID,
              USERID: this.CurentUser[0].USERID,
            };
          }

          this.AddToBasketSubcription = this.memberService
            .NDDAddBasket(this.CurentUser[0].USERID, basketData)
            .pipe(
              switchMap(async (res: any) => {
                switch (res.status) {
                  case 200:
                    if (res.body[0].result == 'True') {
                      swalWithBootstrapButtons.fire(
                        ProcessType == 1
                          ? 'Add to basket success!'
                          : 'Request success!',
                        '',
                        'success'
                      );
                      this.closeModal();

                      if (ProcessType == 2) {
                        this.route.navigateByUrl(
                          '/member/basket?NDDType=' +
                          this.type +
                          '&ddinbasketid=' +
                          res.body[0].ddinbasketid
                        );
                      }
                    } else {
                      Swal.fire({
                        icon: 'error',
                        title: 'Error!',
                        text: res.body[0].message,
                      });
                    }

                    break;
                  default:
                    Swal.fire({
                      icon: 'error',
                      title: 'Oops...',
                      text: 'Unable to connect to API',
                    });
                    break;
                }
              }),
              catchError((e) => {
                Swal.fire({
                  icon: 'error',
                  title: 'Oops...',
                  text: 'Unable to connect to API',
                });
                return of([]);
              })
            )
            .subscribe();
        } else if (result.dismiss === Swal.DismissReason.cancel) {
        }
      });
  }
}

export class textRD {
  TitleModal: string = '';
  NoticeBlockUser: string = '';
  CurrentPage: string = '';
  Custompage: string = '';
  NoticeRequesttoBasket: string = '';
  Price: string = '';
}
